/**
 * THE arrays the app's tail detector reads (main.ts `zoneArraysNow().tail`):
 * the run's subject with the skin AS THE FILE PAINTED IT (adapter
 * zones/file-paint). The run re-owns the buttock and lower back to the pelvis
 * (ADR-029) before the zones panel measures, and the detector's owner cue read
 * that flesh as tail — the kobold's zone climbed 15 cm up the back
 * (2026-09-23). One function, so the app and its test (`tail-app-path`) cannot
 * read two different bodies.
 *
 * Depends on: three, adapter-three (subjectArrays). Depended on by: main.ts
 * (the zone proposer) and the app-path tail tests.
 */
import type { Object3D } from 'three';
import { subjectArrays, type SubjectArrays } from '@harryhausen/adapter-three';

export function tailDetectArrays(scene: Object3D): SubjectArrays {
  return subjectArrays(scene, { paint: 'file' });
}
